export interface UpdateAnswerParams {
    groupId?: number,
    groupOrder?: number,
    questionId: number,
    answerId: string
}

export interface UpdateAnswerObject {
    value?: string,
    errorText?: string,
    status?: StatusUpdateAnswer,
}

export enum StatusUpdateAnswer {
    NONE = "NONE",
    UPDATING = "UPDATING",
    UPDATED = "UPDATED",
    ERROR = "ERROR"
}